<template>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span v-html="status"></span>
</template>

<script>
import statusOrderHTMLUtility from '@/utils/statusOrderHTML';

export default {
    name: 'OrderStatusCellRenderer',
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    computed: {
        value() {
            return this.params.value;
        },
        status() {
            const { value } = this;
            if (!value) {
                return '';
            }
            return statusOrderHTMLUtility(this.value);
        },
    },
};
</script>
